import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  InteractionManager,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';
import { FontAwesomeIcon, KeyboardAwareScrollView } from '../modules';
import LoadingIndicator from '../common/LoadingIndicator';
import APIClient from '../utils/APIClient';
import Utils from '../utils/Utils';
import AlertUtils from '../utils/AlertUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class SellerPriceScreen extends Component {

  static navigationOptions = ({navigation}) => {
    return {
      title: 'Cập nhật thông tin',
      headerBackTitle: null,
    };
  };

  constructor (props) {
    super(props);

    if (Platform.OS === 'web') {
      this._id = this.props.match.params.id;
    } else {
      this._id = this.props.navigation.state.params.id;
    }
    console.log('id: ', this._id);

    this.state = {
      status: 'none',
    };
  }

  componentDidMount () {
    if (Platform.OS === 'web') {
      this._loadData();
    } else {
      InteractionManager.runAfterInteractions(() => {
        this._loadData();
      });
    }
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  _loadData = async () => {
    const {status} = this.state;
    if (status === 'loading') {
      return;
    }

    this.setState({
      status: 'loading',
    });

    const path = `/seller/price/${this._id}`;
    const {response, error} = await APIClient.GET(path);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      this._updateData(response.response);
    } else {
      const message = Utils.parseErrorMessage(response, error,
        'Có lỗi xảy ra, vui lòng thử lại sau');
      AlertUtils.alert({message});
      this.setState({
        status: 'failed',
      });
    }
  }

  _updateData = (data) => {
    const {promoCode, commission, multilevelCommission} = data;
    this.setState({
      data: data,
      promoCode: promoCode,
      commission: `${commission}`,
      multilevelCommission: `${multilevelCommission}`,
      status: 'done',
    });
  };

  _submit = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    this.setState({
      submitting: true,
    });

    const path = `/seller/price/${this._id}`;
    const {data} = this.state;
    const {response, error} = await APIClient.jsonPUT(path, data);
    this._handleSubmitNetworkResponse(response, error);
  };

  _handleSubmitNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    this.setState({
      submitting: false,
    });

    let message;
    if (response && response.response) {
      message = Utils.parseSuccessMessage(response,
        'Cập nhật thông tin thành công');
    } else {
      message = Utils.parseErrorMessage(response, error,
        'Cập nhật thông tin thất bại, vui lòng thử lại sau');
    }
    AlertUtils.alert({
      message,
    });
  }

  _updatePrice = (item, name, text) => {
    let {data} = this.state;
    data = data.map(i => {
      if (i !== item) {
        return i;
      }
      return {
        ...item,
        [name]: text,
      };
    });
    this.setState({
      data: data,
    });
  };

  _renderPriceInfo = (item, index) => {
    const {purchaseTitle, price, saleOff} = item;
    return (
      <View
        key={index}>
        <Text
          style={styles.inputSectionText}>
          Gói {purchaseTitle}
        </Text>

        <Text
          style={styles.inputTitleText}>
          Giá bán
        </Text>
        <View
          style={styles.input}>
          <TextInput
            value={`${price}`}
            placeholder='Giá bán'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            keyboardType='numeric'
            style={styles.textInput}
            onChangeText={(text) => this._updatePrice(item, 'price', text)}/>
        </View>

        <Text
          style={styles.inputTitleText}>
          Giảm giá
        </Text>
        <View
          style={styles.input}>
          <TextInput
            value={`${saleOff}`}
            placeholder='Giảm giá'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            keyboardType='numeric'
            style={styles.textInput}
            onChangeText={(text) => this._updatePrice(item, 'saleOff', text)}/>
        </View>
      </View>
    );
  };

  render () {
    const {data, status, submitting} = this.state;
    return (
      <View
        style={styles.container}>
        {status === 'done' && <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='always'
          containerContentStyle={styles.contentContainer}
          style={styles.container}>

          {!_.isEmpty(data) && data.map(this._renderPriceInfo)}

          <TouchableOpacity
            activeOpacity={0.75}
            onPress={this._submit}
            style={styles.submit}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              CẬP NHẬT
            </Text>
            {submitting && <View
              style={styles.submitting}>
              <ActivityIndicator
                animating
                color='#ffffff'
                style={styles.submittingIndicator}/>
            </View>}
          </TouchableOpacity>
        </KeyboardAwareScrollView>}

        {status === 'loading' && <LoadingIndicator/>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputSectionText: {
    width: contentWidth,
    marginTop: 20,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '500',
    backgroundColor: 'transparent',
  },
  inputTitleText: {
    width: contentWidth,
    marginTop: 8,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

// export default connect(mapStateToProps, mapDispatchToProps)(CreateAgencyScreen);
export default SellerPriceScreen;



// WEBPACK FOOTER //
// ./src/seller/SellerPriceScreen.js